import { render, staticRenderFns } from "./Spider.vue?vue&type=template&id=79ad7aa3&scoped=true&"
import script from "./Spider.vue?vue&type=script&lang=js&"
export * from "./Spider.vue?vue&type=script&lang=js&"
import style0 from "./Spider.vue?vue&type=style&index=0&id=79ad7aa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ad7aa3",
  null
  
)

export default component.exports